/**
 * 構造的静的定数 (docs/15 §1-3 「動的化しすぎない境界線」)。
 * 動的化対象外、shared-types で型として保持。
 */
/**
 * @deprecated 【廃止予定】組込モード 4 種 (モードドリブン化リファクタ 2026-07-24)。
 *
 * mode の唯一の登記簿は Firestore `modeProfiles` (M10 ModeProfile) に一本化された。
 * UI の mode 選択肢はこの定数ではなく useModeProfiles (admin) 経由で取得すること。
 * 本定数は「リファクタ以前に作られた legacy 地区・マスタの mode キー」を識別する
 * fallback (isBuiltInMode) のためだけに残している。新規コードから直接参照しないこと。
 * 撤去条件: legacy fallback (legacyModeResults 地区・静的テンプレ) の全撤去時。
 */
export const DISTRICT_MODES = ['ecw', 'bousai', 'walker', 'kids-bousai'];
/**
 * @deprecated 【廃止予定】mode が組込 4 種か判定 (モードドリブン化リファクタ 2026-07-24)。
 * legacy fallback (静的テンプレ・旧 mode バリデータ) の分岐にのみ使用し、新規コードでは
 * mode キーで挙動を分岐させないこと (設定駆動にする)。
 */
export function isBuiltInMode(mode) {
    return DISTRICT_MODES.includes(mode);
}
/** 投稿フォームのフィールド型 (docs/04 §4-1 FieldDef)。UI 実装に直結するため静的維持。
 *  Sprint BG-DataSettings: 旧 9 型 + v2 拡張 `'textarea'` (postFields の複数行 text)。 */
export const FIELD_TYPES = [
    'text',
    'textarea',
    'select',
    'multiselect',
    'number',
    'checkbox',
    'date',
    'location',
    'photo',
    'rating-scale',
];
/** フィールド表示モード。required / optional / hidden の 3 値。 */
export const FIELD_MODES = ['required', 'optional', 'hidden'];
/** 投稿可視性。docs/04 §4-2 Post 参照。 */
export const POST_VISIBILITIES = ['public', 'hidden_others', 'hidden_all'];
/** 管理者ロール。docs/13 §3-4。 */
export const ADMIN_ROLES = ['master', 'district'];
/** Plutchik 8 感情。理論モデルの根幹、動的化対象外 (docs/15 §12 ECW_EMOTIONS)。 */
export const PLUTCHIK_EMOTIONS = [
    '喜び',
    '信頼',
    '恐れ',
    '驚き',
    '悲しみ',
    '嫌悪',
    '怒り',
    '期待',
];
/**
 * Plutchik 8 感情の自然言語による説明 (旧 `old/packages/shared-types/src/ecwTypes.ts:233-242`
 * `ECW_EMOTION_DESCRIPTIONS` を移植)。
 *
 * 旧 ECW で IdeaCard 保存時に `emotionDescription` field として埋め込まれる。
 * Phase A POC 段階では「旧 IdeaForm が emotionTag → emotionDescription を解決する logic」
 * の 1:1 移植として shared-types に持つ (UI 側で再利用)。
 */
/**
 * Plutchik 8 感情の **標準配色** (「感情の輪 (Wheel of Emotions)」の色相配置に準拠)。
 *
 * 輪の並び (Joy → Trust → Fear → Surprise → Sadness → Disgust → Anger → Anticipation → Joy)
 * がそのまま色相環を一周するよう、黄 → 黄緑 → 緑 → 水色 → 青 → 紫 → 赤 → 橙 の順で割り当てる。
 * 感情どうしの近さ (隣接 = 近い感情) が色の近さで読めるのがこのモデルの利点なので、
 * 個別の色を単独で差し替えないこと (輪の一周が崩れる)。
 *
 * 用途: M2 `aiCategoryMasters` の感情マスタ (`ecw-emotion`) の rows[].color / colorMap 初期値、
 * および master 未ロード時の PDF レポート等の fallback。地区が admin で色を上書きした場合は
 * そちらが優先される (本定数はあくまで既定値)。
 */
export const PLUTCHIK_EMOTION_COLORS = {
    喜び: '#FFD700', // Joy — 黄 (gold)
    信頼: '#A5D610', // Trust — 黄緑
    恐れ: '#2E7D32', // Fear — 緑
    驚き: '#40C4E8', // Surprise — 水色
    悲しみ: '#2E51C8', // Sadness — 青
    嫌悪: '#9C27B0', // Disgust — 紫
    怒り: '#F44336', // Anger — 赤
    期待: '#FF9800', // Anticipation — 橙
};
export const ECW_EMOTION_DESCRIPTIONS = {
    喜び: '楽しい、嬉しい、幸せなどのポジティブな感情。',
    信頼: '安心、安全、信用、頼りになるという感情。',
    恐れ: '危険や不安を感じる感情。',
    驚き: '予想外のことに対する反応。',
    悲しみ: '喪失感やがっかりする気持ち。',
    嫌悪: '不快、嫌い、避けたいという感情。',
    怒り: '不公平や攻撃に対する反応。',
    期待: '将来のことを予想したニュートラルな感情。ポジティブな期待とネガティブな期待がある。',
};
//# sourceMappingURL=index.js.map